import Glide, {Autoplay, Breakpoints, Controls, Swipe} from '@glidejs/glide/dist/glide.modular.esm';

const _carousel = document.querySelector('.js-hero-carousel');

if (_carousel) {
    const glide = new Glide(_carousel, {
        autoplay: 5000,
        type: 'carousel',
        perView: 1,
    });

    glide.mount({Autoplay, Breakpoints, Controls, Swipe});
}
